import type { AgentOtcGetHistoryParams } from '../api'
import { EAgentOtcQueryKey } from './agent-otc.types'
import { getAgentOtcGetHistory } from './agent-otc.service'

export const agentOtcGetHistoryOptions = (
  params: AgentOtcGetHistoryParams,
) => ({
  queryKey: [EAgentOtcQueryKey.AGENT_OTC_GET_HISTORY, params],
  queryFn: () => getAgentOtcGetHistory(params),
})
